/**
 * Time formatting utilities.
 */

/**
 * Format an ISO timestamp as relative time.
 *
 * Returns 'Unknown' for invalid or missing timestamps.
 */
export function formatRelativeTime(isoString: string): string {
  if (!isoString) {
    return 'Unknown'
  }

  const date = new Date(isoString)
  if (Number.isNaN(date.getTime())) {
    return 'Unknown'
  }

  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffSeconds = Math.floor(diffMs / 1000)
  const diffMinutes = Math.floor(diffSeconds / 60)
  const diffHours = Math.floor(diffMinutes / 60)
  const diffDays = Math.floor(diffHours / 24)

  if (diffSeconds < 10) {
    return 'a moment ago'
  }
  if (diffSeconds < 60) {
    return `${diffSeconds}s ago`
  }
  if (diffMinutes < 60) {
    return `${diffMinutes}m ago`
  }
  if (diffHours < 24) {
    return `${diffHours}h ago`
  }
  if (diffDays < 7) {
    return `${diffDays}d ago`
  }

  return date.toLocaleDateString()
}

/**
 * Format a Date as relative time from now.
 */
export function formatRelativeTimeFromDate(date: Date): string {
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffSeconds = Math.floor(diffMs / 1000)
  const diffMinutes = Math.floor(diffSeconds / 60)

  if (diffSeconds < 10) {
    return 'a moment ago'
  }
  if (diffSeconds < 60) {
    return `${diffSeconds}s ago`
  }
  if (diffMinutes < 60) {
    return `${diffMinutes}m ago`
  }

  return date.toLocaleTimeString()
}

export default formatRelativeTime
